import React, { useContext, useEffect } from "react";
import { Box, IconRuler, TextButton } from "@catchoftheday/cg-components";
import { SizeChartsContext } from "./SizeChartContext";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SizeChartsButton = function SizeChartsButton(_ref) {
  var charts = _ref.charts;

  var _useContext = useContext(SizeChartsContext),
      setSizeCharts = _useContext.setSizeCharts,
      setSizeChartOpen = _useContext.setSizeChartOpen;

  useEffect(function () {
    setSizeCharts(charts.map(function (chart) {
      return chart.url;
    }));
  }, [charts, setSizeCharts]);
  return ___EmotionJSX(Box, {
    alignSelf: {
      xs: "center",
      lg: "flex-end"
    },
    mt: "15px"
  }, ___EmotionJSX(TextButton, {
    onClick: function onClick() {
      return setSizeChartOpen(true);
    },
    fontSize: "sm",
    fontWeight: "light"
  }, "Size Chart", ___EmotionJSX(IconRuler, {
    width: "19px",
    height: "12px",
    ml: "5px",
    title: "Size chart"
  })));
};